import React from 'react';
import Router from "./pages/Router"

function App() {
  return (
    <Router></Router>
  );
}

export default App;
